import React, { useState } from 'react';
import { useUI } from '../../DataStore/UIContext';
import ajaxConfig from '../../util/remote/ajaxConfig';
import Notification from '../Common/Notification';
import BsModal from '../Common/BsModal';
import ActivityLoader from '../Common/ActivityLoader';

const AlertConfirmPayment = ({ show, onClose, payment, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { setNotify } = useUI();

  const formatCurrency = (value, currency = 'UGX') => {
    const amount = Number(value || 0);
    return `${currency} ${amount.toLocaleString('en-UG')}`;
  };

  const months = payment?.months || 1;
  const amount = payment?.amount || 0;
  const currency = payment?.currency || 'UGX';
  const planName = payment?.planName || 'OpenFi Standard';
  const organisation = payment?.organisation || 'Your OpenFi Account';

  const confirm = async () => {
    if (!payment) {
      onClose();
      return;
    }

    setLoading(true);

    // 🔁 Adjust this to your actual endpoint name + payload
    const server_response = await ajaxConfig.payLicense({
      months,
      amount,
      organisation_id: payment?.organisation_id,
      currency,
      plan_name: planName,
    });

    setLoading(false);

    if (server_response.status === 'OK') {
      onSuccess?.(server_response);
      setNotify(
        <Notification
          type="success"
          message={server_response.message || 'License payment processed successfully.'}
        />
      );
    } else {
      setNotify(
        <Notification
          type="danger"
          message={server_response.message || 'Failed to process license payment.'}
        />
      );
    }

    onClose();
  };

  const totalLabel = formatCurrency(amount, currency);

  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Confirm License Payment"
      footer={
        <>
          {loading && <ActivityLoader />}
          {!loading && (
            <>
              <button className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              {payment && (
                <button className="btn btn-primary" onClick={confirm}>
                  <i className="fe fe-credit-card mr-1" />
                  Confirm Payment
                </button>
              )}
            </>
          )}
        </>
      }
    >
      {payment && (
        <div className="d-flex justify-content-center align-items-center flex-column text-center">
          <i
            className="fa fa-question-circle text-primary"
            style={{ fontSize: '40px', lineHeight: '1', marginTop: '20px' }}
          ></i>

          <h5 className="mt-2 text-dark" style={{ fontSize: '17px' }}>
            Confirm payment of <b>{totalLabel}</b> via NexumPay?
          </h5>

          <p className="mb-2 mt-2 text-secondary tx-13">
            This payment will extend your <b>{planName}</b> license for{' '}
            <b>
              {months} {months === 1 ? 'month' : 'months'}
            </b>{' '}
            for <b>{organisation}</b>.
          </p>

          <div className="alert alert-info py-2 px-3 mt-2">
            <small className="d-block text-muted">
              <b>Note:</b> Ensure your NexumPay wallet has at least{' '}
              <b>{totalLabel}</b> before confirming. Payments are instant and may be
              non-refundable.
            </small>
          </div>
        </div>
      )}

      {!payment && (
        <div className="text-center text-muted py-4">
          <p className="mb-0">No payment details available.</p>
        </div>
      )}
    </BsModal>
  );
};

export default AlertConfirmPayment;
